import { api } from './api';

// The owner research screen. Choosing an owner in its review window goes
// through the parcel card's own endpoints (mapApi); these are the screen's.
export const ownerResearchApi = {
    status: () => api.get('/owner-research').then((res) => res.data),
    saveSettings: (settings) => api.post('/owner-research/settings', settings).then((res) => res.data),
    runNow: (mode) => api.post('/owner-research/runs', { mode }).then((res) => res.data),
    search: (propertyId) => api.get('/owner-research/search', { q: propertyId }).then((res) => res.data),

    // The whole envelope: meta carries the page count.
    runs: (page) => api.get('/owner-research/runs', { page }),
    // What one run did, property by property — the same endpoint the listing screen reads.
    runItems: (runId, outcome, page) => api.get('/process-runs/' + runId + '/items', { outcome, page }),
    // Narrowed to an agent's territories ("me" for the signed-in member) and/or the list's ZIPs; meta carries the filter applied.
    reviews: (page, filter) => api.get('/owner-research/reviews', { page, ...(filter || {}) }),

    review: (id) => api.get('/owner-research/reviews/' + id).then((res) => res.data),
    resolve: (id, resolution) => api.post('/owner-research/reviews/' + id + '/resolve', { resolution }).then((res) => res.data),
};
